import {Component, EventEmitter, inject, input, OnInit, Output, signal} from '@angular/core';
import {CartegraphTaskIdGenerationSettings} from '../../../../../shared/models/cartegraph.model';
import {ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {MatProgressSpinner} from '@angular/material/progress-spinner';
import {MatError, MatFormField, MatInput} from '@angular/material/input';
import {CardContentDirective} from '../../../../../shared/components/card/card-content.directive';
import {RowWithToggleComponent} from '../../row-with-toggle/row-with-toggle.component';


@Component({
  selector: 'app-cartegraph-custom-task-id',
  templateUrl: './cartegraph-task-id-settings.component.html',
  styleUrls: ['../../../settings-fields.scss',
    '../../../settings-common.scss'],
  imports: [
    MatProgressSpinner,
    ReactiveFormsModule,
    MatError,
    MatFormField,
    MatInput,
    CardContentDirective,
    RowWithToggleComponent
  ],
  standalone: true,
})
export class CartegraphTaskIdSettingsComponent implements OnInit {

  private fb = inject(UntypedFormBuilder);

  protected isLoading = signal(false);

  @Output()
  defaultsChange = new EventEmitter<CartegraphTaskIdGenerationSettings>(false);

  taskIdentification = input<CartegraphTaskIdGenerationSettings>();

  uiError: string;
  form: UntypedFormGroup;

  ngOnInit(): void {
    this.initForm();
  }

  canBeSaved() {
    return (this.form?.valid ?? true);
  }

  protected initForm() {

    // init form
    this.form = this.fb.group({
      prefix: this.fb.control(this.taskIdentification().prefix, [Validators.required]),
      useShiftId: this.fb.control(this.taskIdentification().useShiftId, [Validators.required]),
    });

    // notify changes
    this.form.valueChanges.subscribe(() => {
      this.isLoading.set(true);

      const {prefix, useShiftId} = this.form.value;

      const idSettings = Object.assign({},
        this.taskIdentification(),
        {prefix, useShiftId} as unknown as CartegraphTaskIdGenerationSettings);

      // only notify if the object is valid and can be saved
      if (this.canBeSaved()) {
        this.defaultsChange.emit(idSettings);
      }

      this.isLoading.set(false);
    });

  }

}
